import { Database, Plus } from "lucide-react";
import React from "react";
import { Button } from "../ui/button";
import { PageHeader } from "../ui/page-header";

export function ServicesView() {
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Workspace"
        title="Services"
        description="Manage your infrastructure services and databases"
        actions={
        <Button disabled>
          <Plus className="h-4 w-4 mr-2" />
          New Service
        </Button>
        }
      />

      {/* Empty State */}
      <div className="text-center py-12">
        <Database className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
        <h3 className="text-h4 mb-2">No services yet</h3>
        <p className="text-muted-foreground mb-6 max-w-sm mx-auto">
          Services like databases, Redis, and other infrastructure components
          will appear here once you create them.
        </p>
        <Button variant="outline" disabled>
          <Plus className="h-4 w-4 mr-2" />
          Create your first service
        </Button>
      </div>
    </div>
  );
}
